import React from "react";
import { persistor, store } from "@/redux/store";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "@material-tailwind/react";
import App from "./App";
import "./Scss/main.scss";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ThemeProvider>
        <App />
        <ToastContainer limit={2} />
      </ThemeProvider>
    </PersistGate>
  </Provider>
);
